<template>
  <section>
    <div class="blocked_warning">
      <div class="flex">
        <div class="icon">
          <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
        </div>
        <div class="content">
          <div class="tips">
            {{waringTitle}}
          </div>
          <div class="list">
            <ul>
              <li
                v-for="(item, i) in list"
                :key="i">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span v-if="isBtn">
        <v-button
          green
          @click="handleClick">{{btnText}}</v-button>
      </span>
    </div>

  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'BlockWarningList',
  mixins: [MixinOptions],
  props:{
    list:{
      type: Array,
      default: () => []
    },
    waringTitle:{
      type: String,
      default: ''
    },
    isBtn:{
      type: Boolean,
      default: true
    },
    btnText:{
      type: String,
      default: 'Send SMS'
    }
  },
  data () {
    return {

    }
  },
  computed:{
  },
  methods: {
    handleClick(){
      this.$emit('click')
    }
  },
}
</script>
<style lang='scss' scoped>
.blocked_warning{
  padding: 15px;
  background: #FFE3E6;
  border: 1px solid rgba(158, 28, 35, 0.2);
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon{
    font-size: 14px;
    color: #CB2431;
  }
  .content{
    margin-left: 16px;
    margin-right: 70px;
    .tips{
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
    }
    .list{
      margin-top: 15px;
      ul{
        padding-left: 20px;
        li{
          font-weight: 400;
          font-size: 14px;
          color: #24292E;
          line-height: 20px;
          &.list-style__none{
            list-style: none;
          }
        }
      }
    }
  }
}
</style>
